<div class="grid align-items-end vertical-container fluid ">
  <div class="col-8">
    <h5>В новом документе ({{count}})</h5>
    <p-selectButton [options]="actions" [(ngModel)]="selectedActions" multiple="true" optionLabel="name" optionValue="value" (onChange)="onDocTypeChanges($event)"></p-selectButton>
  </div>
  <div class="col-2">
    <p-button label="Очистить" icon="pi pi-trash" (onClick)="onClearRows($event)" styleClass="ml-2 mt-2 mr-2" [disabled]="false"
              pTooltip="Очистить содержимое нового документа" tooltipPosition="top"></p-button>
  </div>
  <div class="col-2">
    <p-button label="Сначала" icon="pi pi-undo" (onClick)="onRefreshRows($event)" styleClass="ml-2 mt-2 mr-2" [disabled]="false"
              pTooltip="Обновить содержимое нового документа" tooltipPosition="top"></p-button>
  </div>
</div>
